import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ExpertsDataService, ExpertsColumnsService } from '../../../services';
import { Experts, ExpertsResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-expert-form',
  templateUrl: './expert-form.component.html',
  styleUrls: ['./expert-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ExpertFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public expert: Experts = {};
  public expertForm: FormGroup = new FormGroup({});
  public experts: Experts[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private expertsDataService: ExpertsDataService,
    public expertsColumnsService: ExpertsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ExpertFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Expert - Edit');
        this.getCoach(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.expert !== 'undefined') {
      this.expert = this.dynamicDialogConfig.data.expert;
    }
    if (typeof this.expert.id === 'undefined' || this.expert.id === null) {
      this.expert.id = null;
      this.expert.isPublished = false;
    }
    this.getExperts();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'CoachFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'CoachFormComponent');
  }

  getCoach(id: number): void {
    this.isLoading = true;
    this.expertsDataService.getExpert(id).subscribe((response: Experts|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.expert = response;
        this.prepareFrom();
      }
    });
  }

  getExperts(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.experts !== 'undefined' && this.dynamicDialogConfig.data.experts.length > 0) {
      this.experts = this.dynamicDialogConfig.data.experts;
      return;
    }
    this.expertsDataService.getExperts(this.parameters).subscribe((response: ExpertsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.experts = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.expertForm = new FormGroup({
      id: new FormControl(this.expert.id, []),
      name: new FormControl(this.expert.name, [Validators.required, ]),
      nameAr: new FormControl(this.expert.nameAr, []),
      nameFr: new FormControl(this.expert.nameFr, []),
      job: new FormControl(this.expert.job, [Validators.required,]),
      jobAr: new FormControl(this.expert.jobAr, [Validators.required,]),
      description: new FormControl(this.expert.description, []),
      photo: new FormControl(this.expert.photo, []),
      isPublished: new FormControl(this.expert.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/experts']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.expertForm.controls).forEach((field: any) => {
        const control = this.expertForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.expertForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.expert = this.expertForm.value;
    this.disableSubmit = true;
    console.log('expert', this.expert);
    if (typeof this.expert.id !== 'undefined' && this.expert.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.expertsDataService.updateExpert(this.expert).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('COACHUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('COACHNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.expertsDataService.addExpert(this.expert).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('COACHCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('COACHNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.expertForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'experts',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.expertForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-expert-form',
  templateUrl: './expert-form.component.html',
  styleUrls: ['./expert-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogExpertFormComponent extends ExpertFormComponent {
}

